import { Link, Modal } from '@carbon/react';
import React, { useCallback } from 'react';

import './_override.scss';
import useModal from '@/lib/hooks/useModal';

export const VideoModalLink = ({
  url = '',
  detail = '',
  label = '',
  children,
}) => {

  const [showVideoModal] = useModal('SHOW_VIDEO');
  const openVideoModal = useCallback(() => {
    showVideoModal({ url, detail, label });
  }, [showVideoModal, url, detail, label]);

  return (
    <Link href="#" onClick={openVideoModal}>
      {children}
    </Link>
  );
};

export const VideoModal = ({ url, label = 'Video', hideModal }) => {
  return (
    <Modal
      className="video-modal"
      open={true}
      danger={false}
      size="lg"
      primaryButtonText="Ok"
      secondaryButtonText="Abbrechen"
      modalHeading={label}
      onRequestClose={hideModal}
      onRequestSubmit={hideModal}>
      <video className="video-player" controls>
        <source src={url} />
      </video>
    </Modal>
  );
};
